import { useEffect, useRef } from 'react';

/**
 * Hook to track if a component is currently mounted.
 * Useful for preventing setState calls on unmounted components.
 *
 * @returns {React.MutableRefObject<boolean>} ref.current is true when mounted, false when unmounted
 */
export default function useIsMounted() {
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  return isMounted;
}
